import axios from "../../helpers/httpClient";

export default {
    //FUNCTION EXPORT DATA
    exportData: async ({ commit, dispatch, state }, data) => {

        try {

            // Start loader
            commit('SET_LOADER', true);

            const file = await axios({
                url: `/files/exportarData`,
                method: 'GET',
                responseType: 'blob',
                headers: { 'Content-Type': 'application/json' },
                params: {...data},
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (file.status === 200) {

                let formato = (data.formato === 'XLSX (Excel)')
                    ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    : 'application/pdf'

                var fileURL = window.URL.createObjectURL(new Blob([file.data], { type: formato }));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', `${data.nombre}`);
                document.body.appendChild(fileLink);

                fileLink.click();
                document.body.removeChild(fileLink);
                window.URL.revokeObjectURL(fileURL);

                dispatch('activeMessageCorrect', 'Información descargada correctamente!!')
                return 'ok'

            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    downloadImportFormat: async ({ commit, dispatch, state }, data) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let file;
            let file2;

            if (data.dataToImport2) {
                file = await axios({
                    url: `/files/downloadImportFormat`,
                    method: 'GET',
                    responseType: 'blob',
                    headers: { 'Content-Type': 'application/json' },
                    params: {
                        dataToImport: data.dataToImport,
                        header: data.header,
                    },
                });

                file2 = await axios({
                    url: `/files/downloadImportFormat`,
                    method: 'GET',
                    responseType: 'blob',
                    headers: { 'Content-Type': 'application/json' },
                    params: {
                        dataToImport: data.dataToImport2,
                        header: data.header2,
                    },
                });
            } else {
                file = await axios({
                    url: `/files/downloadImportFormat`,
                    method: 'GET',
                    responseType: 'blob',
                    headers: { 'Content-Type': 'application/json' },
                    params: {...data},
                });
            }

            // Stop Loader
            commit('SET_LOADER', false);

            let formato = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            
            if (data.dataToImport2) {
                if (file.status === 200 && file2.status === 200) {
                    // file 1
                    var fileURL = window.URL.createObjectURL(new Blob([file.data], { type: formato }));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', `${data.name}`);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    document.body.removeChild(fileLink);
                    window.URL.revokeObjectURL(fileURL);
                    
                    // file 2
                    var fileURL2 = window.URL.createObjectURL(new Blob([file2.data], { type: formato }));
                    var fileLink2 = document.createElement('a');
                    fileLink2.href = fileURL2;
                    fileLink2.setAttribute('download', `${data.name2}`);
                    document.body.appendChild(fileLink2);
                    fileLink2.click();
                    document.body.removeChild(fileLink2);
                    window.URL.revokeObjectURL(fileURL2);
    
                    dispatch('activeMessageCorrect', 'Información descargada correctamente!')
                    return 'ok'
                }
            } else {
                if (file.status === 200) {
                    var fileURL = window.URL.createObjectURL(new Blob([file.data], { type: formato }));
                    var fileLink = document.createElement('a');
    
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', `${data.name}`);
                    document.body.appendChild(fileLink);
    
                    fileLink.click();
                    document.body.removeChild(fileLink);
                    window.URL.revokeObjectURL(fileURL);
    
                    dispatch('activeMessageCorrect', 'Información descargada correctamente')
                    return 'ok'
                }
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
}